import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { CompanyGuard } from "./core/guards/company.guard";
import { RoleGuard } from "./core/guards/role.guard";
import { ErrorPageComponent } from "./features/error-page/error-page.component";
import { SimulationGuard } from "./core/guards/simulation.guard";

export const ONLINE_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    canActivate: [MsalGuard],
    loadComponent: () => import('./features/homepage/homepage.component').then((m) => m.HomepageComponent)
  },
  {
    path: 'data-change',
    canActivate: [MsalGuard, SimulationGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/data-change/data-change.routes').then((m) => m.DATA_CHANGE_ROUTES),
    data: { roles: ['*Developer'] }
  },
  {
    path: 'simulation',
    canActivate: [MsalGuard, SimulationGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/simulations/simulations.routes').then((m) => m.SIMULATIONS_ROUTES),
    data: { roles: ['*Developer'] }
  },
  // {
  //   path: 'company',
  //   canActivate: [MsalGuard, RoleGuard],
  //   loadChildren: () => import('./features/companies/companies.routes').then((m) => m.COMPANYS_ROUTES),
  //   data: { roles: ['Admin'] }
  // },
  {
    path: 'deflaker',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/deflaker/deflaker.routes').then((m) => m.DEFLAKER_ROUTES),
    data: { roles: ['DeflakerBasic'] }
  },
  {
    path: 'hydrascreen',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/hydra-screen/hydra-screen.routes').then((m) => m.HYDRA_SCREEN_ROUTES),
    data: { roles: ['HydraScreenBasic'] }
  },
  {
    path: 'fsupulper',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/fsu-pulper/fsu-pulper.routes').then((m) => m.FSU_PULPER_ROUTES),
    data: { roles: ['FsuPulperBasic'] }
  },
  {
    path: 'hcrefiner',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/hc-refiner/hc-refiner.routes').then((m) => m.HC_REFINER_ROUTES),
    data: { roles: ['HcRefinerBasic'] }
  },
  {
    path: 'project',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/projects/project.routes').then((m) => m.PROJECT_ROUTES),
    data: { roles: ['*Standard'] }
  },
  {
    path: 'project-calculation',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/project-calculations/project-calculation.routes').then((m) => m.PROJECT_CALCULATION_ROUTES),
    data: { roles: ['*Standard'] }
  },
  {
    path: 'modules',
    canActivate: [MsalGuard, CompanyGuard],
    loadChildren: () => import('./features/modules/modules.routes').then((m) => m.MODULES_ROUTES)
  },
  {
    path: 'recent-calculations',
    canActivate: [MsalGuard, CompanyGuard],
    loadChildren: () => import('./features/recent-calculations/recent-calculations.routes').then((m) => m.RECENT_CALCULATIONS_ROUTES)
  },
  {
    path: 'micrascreen',
    canActivate: [MsalGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/micra-screen/micra-screen.routes').then((m) => m.MICRA_SCREEN_ROUTES),
    data: { roles: ['MicraScreenBasic'] }
  },
  {
    path: 'user-settings',
    canActivate: [MsalGuard, RoleGuard],
    loadChildren: () => import('./features/user-settings/user-settings.routes').then((m) => m.USER_SETTINGS_ROUTES),
    data: { roles: ['Admin', 'AdminReginonal'] }
  },
  {
    path: 'no-registered',
    canActivate: [MsalGuard],
    component: ErrorPageComponent,
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 401,
      title: 'User is not registered in SizingTools application',
      description: 'Please contact your application administrator',
      url: '',
      label: '',
    },
  },
  {
    path: 'no-permission',
    canActivate: [MsalGuard],
    component: ErrorPageComponent,
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 403,
      title: 'Permission denied.',
      description: 'Please contact your application administrator',
      url: '',
      label: '',
    },
  },
  {
    path: '404',
    component: ErrorPageComponent,
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 404,
      title: 'Page not found.',
      description: '',
      url: '/',
      label: 'Go Home',
    },
  },
  {
    path: '**',
    redirectTo: '404',
  },
];